<template>
      <v-flex xs12 md4>
        <v-dialog
          v-model="dialogScript"
          width="1000"
          hegiht="auto"
        >
          <template v-slot:activator="{ on }">
            
                <v-flex
                  xs12
                  md4
                >
            <v-btn
              color="success"
              dark
              v-on="on"
            >
              Upload Script 
            </v-btn>
            
                </v-flex>
          </template>

          <v-card>
        
            <FormScript
              :Item="item"
              :Value="valueObj"
              @emitted="getScriptData"
              />

          </v-card>
        </v-dialog>
        <material-card
        
          color="green"
          title="Script List"
          text=""
        >

          <v-data-table
            :headers="scriptHeaders"
            :items="scriptList"
            
          >
            <template
              slot="headerCell"
              slot-scope="{ header }"
            >
              <span
                class="subheading font-weight-light text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              slot="items"
              slot-scope="{ item }"
            >
              <td>{{ item.title }}</td>
              <td>{{ item.description }}</td>
            </template>
          </v-data-table>
        </material-card>

            <v-snackbar
              :color="color"
              :bottom="bottom"
              :top="top"
              :left="left"
              :right="right"
              v-model="snackbar"
              dark
            >
              <v-icon
                color="white"
                class="mr-3"
              >
                mdi-bell-plus
              </v-icon>
              <div>Warning! {{ noticeMessage }}</div>
              <v-icon
                size="16"
                @click="snackbar = false"
              >
                mdi-close-circle
              </v-icon>
            </v-snackbar>
      </v-flex>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import FormLecture from '@/views/FormLecture'
import FormScript from '@/views/FormScript'
import ChapterExam from '@/views/ChapterExam'
import Form from '@/views/Form'
export default {
  components: {
    Form,
    FormLecture,
    ChapterExam,
    FormScript
  },
  computed: {
    // ...mapGetters("courses", ["course", "name", "courseList"]),
    ...mapState('lectures', ['scriptList']),
  },
  mounted () {
    this.getLectureListByChapterId(this.$route.params.id)
  },
  data () {
    return {
    color: null,
    colors: [
      'warning'
    ],
    top: true,
    bottom: false,
    left: false,
    right: false,
    snackbar: false,
      
    
    scriptHeaders: [
      {
        sortable: true,
        text: 'Title',
        value: 'title'
      },
      {
        sortable: false,
        text: 'Description',
        value: 'description'
      }
    ],
      dialog: false,
      dialogScript: false,
      examDialog: false,
      noticeMessage: '',
      item: {
        'title': 'Create new',
        'subTitle': 'This is the subtitle',
        'width': 'md6',
        'submitText' : 'Submit'
      },
      valueObj: {}
    }
  },
  created () {
    
      this.valueObj = {
        'chapter_id' : this.$route.params.id,
        'course_id' : this.$route.params.courseId,
        'subject_id' : this.$route.params.subjectId
       }
       console.log(this.valueObj)
  },

  methods: {
    ...mapActions("lectures", ["getLectureListByChapterId", 'getScriptlistByChapterId', 'storeChapterScript', 'storeLectureVideo']),
 
    getScriptData (data) {
      data.chapter_id = this.$route.params.id
      data.subject_id = this.$route.params.subjectId
      this.storeChapterScript(data).then((response) => {
        console.log(response)
        if (response.status == 'OK') {
          this.getScriptlistByChapterId(this.$route.params.id)
          this.dialogScript = false
            this.color= 'success'
          this.noticeMessage = response.messages
          this.snack('top')
        } else {
          this.noticeMessage = response.messages
          this.snack('top')
        }
      }).catch((err) => {
        console.log(err)
      })

      console.log(data)
    },
    
    snack (...args) {
      this.top = false
      this.bottom = false
      this.left = false
      this.right = false

      for (const loc of args) {
        this[loc] = true
      }


      this.snackbar = true
    }
  }
}
</script>
